/**
 * Action model
 */

import { Command, SetupCommandData } from './Command';
import { Condition, SetupConditionData } from './Condition';
import { EnhancedInputData, SetupEnhInputData } from './EnhancedInputData';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];

export class Action {
    name: string = "default";
    bActive: boolean = true;
    overridename: string = "";
    actionparent: string = "None";
    bConditionFailOnFirst: boolean = true;
    InputType: string = "None";
    PassCommands: (Command | Condition)[] = [];
    FailCommands: (Command | Condition)[] = [];
    Conditions: Condition[] = [];
    CustomChoices: string[] = [];
    EnhInputData: EnhancedInputData = new EnhancedInputData();
    CustomChoiceTitle: string = "";
    AdvancedScript: string = "";
    UseAdvancedScript: boolean = false;

    // Which room/object/character/timer/player owns that action
    _owner: any = undefined;

    cloneForDiff(): {
        name: string;
        bActive: boolean;
        overridename: string;
        actionparent: string;
        InputType: string;
        CustomChoices: any[];
    } {
        return {
            name: this.name,
            bActive: this.bActive,
            overridename: this.overridename,
            actionparent: this.actionparent,
            InputType: this.InputType,
            CustomChoices: (window as any).ArrayCloneForDiff?.(this.CustomChoices) || this.CustomChoices.slice(),
        };
    }
}

export function SetupActionData(GameData: any[]): Action {
    const CurAction = new Action();
    CurAction.name = GameData[0];
    CurAction.bActive = GameData[1];
    CurAction.overridename = GameData[2];
    CurAction.actionparent = GameData[3];
    CurAction.bConditionFailOnFirst = GameData[4];
    CurAction.InputType = GameData[5];
    CurAction.CustomChoiceTitle = GameData[6];
    for (let i = 0; i < GameData[7].length; i++) {
        if (GameData[7][i][0] === "CMD") {
            CurAction.PassCommands.push(SetupCommandData(GameData[7][i]));
        } else {
            CurAction.PassCommands.push(SetupConditionData(GameData[7][i]));
        }
    }

    for (let j = 0; j < GameData[8].length; j++) {
        if (GameData[8][j][0] === "CMD") {
            CurAction.FailCommands.push(SetupCommandData(GameData[8][j]));
        } else {
            CurAction.FailCommands.push(SetupConditionData(GameData[8][j]));
        }
    }

    for (let k = 0; k < GameData[9].length; k++) {
        CurAction.Conditions.push(SetupConditionData(GameData[9][k]));
    }

    for (let l = 0; l < GameData[10].length; l++) {
        CurAction.CustomChoices.push(GameData[10][l]);
    }

    CurAction.EnhInputData = SetupEnhInputData(GameData[11]);
    CurAction.AdvancedScript = typeof GameData[12] === 'string' ? GameData[12] : "";
    CurAction.UseAdvancedScript = Boolean(GameData[13]);
    return CurAction;
}
